module.exports = "https://cdn-shared.mathletics.com/teacher-modules/upf-assign/73/assets/images/9b0748c0988a24be68e1e55010c413f6.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_dropdown.svg
// module id = z7ov
// module chunks = 0